import { ComponentProps } from 'react';
import { ShowMoreButton } from './ShowMoreButton';

interface FetcherPaginationProps extends ComponentProps<typeof ShowMoreButton> {
  moreItems?: () => boolean;
  fetchNext?: () => void;
  renderLoading?: () => JSX.Element;
}

export const FetcherPagination = ({
  moreItems,
  fetchNext,
  isLoading,
  renderLoading,
  ...rest
}: FetcherPaginationProps): JSX.Element | null => {
  if (!moreItems || !moreItems()) {
    return null;
  }

  if (isLoading && renderLoading) {
    return renderLoading();
  }

  return <ShowMoreButton onClick={fetchNext} isLoading={isLoading} {...rest} />;
};
